import DefaultExceptionTypes from "./DefaultExceptionTypes";
import Exception from "./Exception";

/**
 * Ce que le navigateur répond quand le serveur ne répond pas du tout. Le message est comparé en entier : « Failed to fetch codes »,
 * écrit par l'application, n'est pas une coupure réseau.
 */
const NETWORK_FAILURE = /^(typeerror: )?(failed to fetch|load failed|networkerror when attempting to fetch resource\.?|network request failed|fetch failed)$/i;

/** Vrai si l'erreur est celle d'un service injoignable (serveur arrêté, coupure réseau, délai dépassé), et non un refus du serveur. */
export function isNetworkFailure(error: unknown): boolean {
  if (typeof error !== "object" || error === null) {
    return false;
  }
  const { name, message, type } = error as { name?: unknown; message?: unknown; type?: unknown };
  return (
    type === DefaultExceptionTypes.NETWORK_ERROR ||
    name === "TimeoutError" ||
    name === "AbortError" ||
    (typeof message === "string" && NETWORK_FAILURE.test(message.trim()))
  );
}

/** L'exception d'un service injoignable : le type seul porte le sens, l'écran choisit sa langue et son wording. */
export function serviceUnavailableException(): Exception<unknown, DefaultExceptionTypes> {
  return { type: DefaultExceptionTypes.NETWORK_ERROR };
}

/** Vrai si l'exception d'un écran est celle d'un service injoignable. */
export function isServiceUnavailable(exception: { type?: unknown } | null | undefined): boolean {
  return exception?.type === DefaultExceptionTypes.NETWORK_ERROR;
}
